import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Badge, Card, Alert, Loader } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import PageShell from '@/components/layout/PageShell';
import PageHeader from '@/components/layout/PageHeader';

function apiError(ex) {
  return (ex.response && ex.response.data && ex.response.data.error) || ex.message;
}

function sentimentVariant(sentiment) {
  if (sentiment === 'up' || sentiment === 'positive') return 'success';
  if (sentiment === 'down' || sentiment === 'negative') return 'error';
  return 'secondary';
}

export default function AgentFeedbackDetail() {
  const { id } = useParams();
  const { fetchApi } = useAppApi();

  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetchApi('crud', { model: 'AppAgentFeedback', action: 'show', where: { id } })
      .then((res) => setRow(res.data || res))
      .catch((ex) => setErr(apiError(ex)))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <PageShell><Loader text="Loading feedback…" /></PageShell>;
  if (!row) return <PageShell><Alert variant="error" title="Could not load">{err || 'Feedback not found'}</Alert></PageShell>;

  return (
    <PageShell width="narrow" className="space-y-3">
      <PageHeader backTo="/app-agent-feedback" backLabel="Agent Feedback" title="Feedback Detail" />

      {err && <Alert variant="error" title="Error">{err}</Alert>}

      <Card className="p-3 space-y-4">
        <div className="space-y-2">
          <div className="text-xs uppercase text-secondary-500">Question</div>
          <p className="text-sm whitespace-pre-wrap">{row.question || '—'}</p>
        </div>

        <div className="space-y-2">
          <div className="text-xs uppercase text-secondary-500">Answer</div>
          <p className="text-sm whitespace-pre-wrap">{row.answer || '—'}</p>
        </div>

        {row.comment && (
          <div className="space-y-2">
            <div className="text-xs uppercase text-secondary-500">Comment</div>
            <p className="text-sm whitespace-pre-wrap">{row.comment}</p>
          </div>
        )}

        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs uppercase text-secondary-500 mb-1">Sentiment</div>
            <Badge variant={sentimentVariant(row.sentiment)} size="sm">{row.sentiment || '—'}</Badge>
          </div>
          <div>
            <div className="text-xs uppercase text-secondary-500 mb-1">Session</div>
            <p className="text-sm font-mono">{row.session_id || '—'}</p>
          </div>
          <div>
            <div className="text-xs uppercase text-secondary-500 mb-1">Agent</div>
            <p className="text-sm font-mono">{row.agent_key || '—'}</p>
          </div>
          <div>
            <div className="text-xs uppercase text-secondary-500 mb-1">Created</div>
            <p className="text-sm text-secondary-500">{row.created_at ? new Date(row.created_at).toLocaleString() : '—'}</p>
          </div>
        </div>
      </Card>
    </PageShell>
  );
}
